interface IDashboardMenus {
  title: string
  icon: string
  path: string
  description?: string
  hidden?: boolean
  permission?: string
}

export const SIDEBAR_EXPAND_WIDTH = 280
export const SIDEBAR_COLLAPSED_WIDTH = 72

export const APP_MENU: Record<string, { name: string | null; routes: IDashboardMenus[] }> = {
  main: {
    name: null,
    routes: [
      {
        title: 'menu.stats',
        icon: 'lucide:chart-column',
        path: 'home'
      },
      {
        title: 'menu.activities',
        icon: 'lucide:calendar',
        path: 'activities-management',
        description: 'menu.activities_description',
        permission: 'events.admin_events.read'
      },
      {
        title: 'menu.coordinators',
        icon: 'lucide:users',
        path: 'coordinators',
        description: 'menu.coordinators_description',
        permission: 'events.admin_planners.read'
      },
      {
        title: 'menu.tickets',
        icon: 'lucide:file-text',
        path: 'tickets',
        description: 'menu.tickets_description',
        permission: 'events.admin_ticket_sales.read'
      },
      {
        title: 'menu.event_categories',
        icon: 'tabler:category-2',
        path: 'event-categories',
        description: 'menu.event_categories_description',
        permission: 'events.admin_categories.read'
      },
      {
        title: 'menu.permissions',
        icon: 'tabler:user-key',
        path: 'permissions',
        description: 'menu.permissions_description',
        permission: 'events.admin_permissions.read'
      },
      {
        title: 'menu.roles',
        icon: 'lucide:user-cog',
        path: 'roles',
        description: 'menu.roles_description',
        permission: 'events.admin_roles.read'
      },
      {
        title: 'menu.supervisors',
        icon: 'solar:user-linear',
        path: 'supervisors',
        description: 'menu.supervisors_description',
        permission: 'users.admin_users.read'
      }
    ]
  }
}

export const globalSearch = {}
